module.exports = __webpack_public_path__ + "static/media/Nibss-LOG3O-horizontal.d3fab78f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/Nibss-LOG3O-horizontal.png
// module id = 583
// module chunks = 0